module.exports = __webpack_public_path__ + "static/media/maintenance_management_icon.ac97bd13.png";